import React, { useCallback, useEffect, useState } from 'react'
import Day from './Day'
import { BsDot } from 'react-icons/bs';
import Image from 'next/image'

const days = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"]

const TimeCalc = () => {

   const [data, setData] = useState({});
   const [workHours, setWorkHours] = useState("")
   const [autoCalculate, setAutoCalculate] = useState(false)
   const [resetBtn, setResetBtn] = useState(false)

   const handleClick = () => {
      setResetBtn(true);
      setData({})
      setWorkHours("")
      setTimeout(() => {
         setResetBtn(false);
      }, 1000);
   };

   const handleDataChange = (key, value) => {
      setData({ ...data, [key]: value });
   };

   const calculateTotalWorkHours = useCallback(() => {

      let totalMinutes = 0;
      Object.values(data).forEach(value => {
         const [hours, minutes] = value.split(':').map(Number);
         totalMinutes += hours * 60 + minutes;
      });

      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;

      const formattedHours = `${hours}:${minutes.toString().padStart(2, '0')}`;
      // console.log(formattedHours)
      setWorkHours(formattedHours)

   }, [data]);

   useEffect(() => {
      if (autoCalculate) {
         calculateTotalWorkHours();
      }
   }, [autoCalculate, calculateTotalWorkHours])

   return (
      <div className="w-full lg:w-[586px] h-fit bg-white drop-shadow-xl rounded-xl pt-[25px] mx-auto">
         <div className="flex justify-between w-[100%] px-[25px]">
            <h1 className="text-[23px] font-medium leading-[25px] w-[80%] md:w-[60%]">Calculate the hours you are owed.</h1>
            <button type="reset" onClick={handleClick} className="text-red-500 w-[100px] text-[15px] font-medium flex items-center gap-[5px] ml-[20px]">
               <Image src="https://weareindy.com/icons/clear.svg" width="15" height="15" alt="" /> Clear all
            </button>
         </div>
         <div className="w-full h-[1px] bg-gray-300 my-[20px]"></div>
         <div className="flex flex-col gap-[2px] justify-between items-center px-[10px] sm:px-[25px] pb-[25px]">
            <div className="flex justify-between text-[13px] font-medium text-gray-700 w-full border-b-[1px] pb-[10px] mb-[10px]">
               <div className="w-[56px]">Day</div>
               <div className="w-[154px]">Start time</div>
               <div className="w-[154px]">End time</div>
               <div className="w-[91px]">Est. break</div>
               <div className="w-[67px]">Work time</div>
            </div>
            {
               days.map((d) => {
                  return (
                     <Day onHandleData={handleDataChange} resetBtn={resetBtn} day={d} key={d} />
                  )
               })
            }
            <div className="flex justify-end items-center gap-[20px] font-medium text-gray-800 w-full my-[20px]">
               <div className="w-fit text-[16px]">Total Work Time</div>
               <div className="w-[67px] flex justify-center text-[16px]">{workHours !== "" ? workHours : "00:00"}</div>
            </div>
            <div className="flex justify-end items-center gap-[20px] font-medium w-full pb-[20px]">
               {
                  workHours ?
                     <p className="text-green-500 flex items-center text-[14px] pr-[10px]"><BsDot />Auto Calculate</p>
                     :
                     <button type="button" onClick={() => { calculateTotalWorkHours(); setAutoCalculate(true); }} className="bg-emerald-500 font-medium text-[18px] py-[12px] px-[80px] text-white rounded-[40px]">Calculate</button>

               }
            </div>
         </div>
         {/* {
            autoCalculate &&
            <div className="bg-violet-300 px-[30px] pt-[5px] pb-[25px] rounded-b-xl relative">
               <div className="flex justify-center items-center -translate-y-[30px]">
                  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" class="style_question__WXNc_"><circle cx="24" cy="24" fill="#FCFCFC" r="15"></circle><path d="M42.35 19.278c-.708-.738-1.439-1.5-1.715-2.168-.254-.614-.27-1.63-.285-2.614-.027-1.83-.058-3.904-1.5-5.345-1.442-1.442-3.516-1.473-5.346-1.501-.983-.015-2-.03-2.613-.284-.668-.277-1.43-1.008-2.168-1.715C27.427 4.408 25.958 3 24 3c-1.957 0-3.426 1.408-4.722 2.65-.737.708-1.5 1.44-2.168 1.716-.613.254-1.63.27-2.613.284-1.83.028-3.904.059-5.346 1.5-1.442 1.442-1.473 3.516-1.5 5.346-.015.983-.03 2-.285 2.614-.276.668-1.007 1.43-1.715 2.168-1.242 1.295-2.65 2.764-2.65 4.722 0 1.958 1.408 3.427 2.65 4.722.708.738 1.439 1.5 1.715 2.168.254.614.27 1.63.284 2.614.028 1.83.06 3.904 1.501 5.345 1.442 1.442 3.516 1.473 5.346 1.501.983.015 2 .03 2.613.284.668.276 1.43 1.008 2.168 1.715C20.574 43.592 22.043 45 24.001 45c1.957 0 3.426-1.408 4.722-2.65.737-.708 1.5-1.44 2.168-1.716.614-.254 1.63-.27 2.613-.284 1.83-.028 3.904-.059 5.346-1.5 1.442-1.443 1.473-3.516 1.5-5.346.015-.983.03-2 .285-2.614.276-.668 1.007-1.43 1.715-2.168C43.592 27.427 45 25.958 45 24c0-1.958-1.408-3.427-2.65-4.722zM24 36a2.25 2.25 0 110-4.5 2.25 2.25 0 010 4.5zm1.5-9.167v.168a1.5 1.5 0 11-3 0v-1.5A1.5 1.5 0 0124 24a3.75 3.75 0 10-3.75-3.75 1.5 1.5 0 11-3 0 6.75 6.75 0 118.25 6.582z" fill="url(#question_svg__paint0_linear_1148:20026)"></path><defs><linearGradient id="question_svg__paint0_linear_1148:20026" x1="3" y1="45" x2="53.574" y2="15.348" gradientUnits="userSpaceOnUse"><stop stop-color="#4c36b1"></stop><stop offset="1" stop-color="#A678F4"></stop></linearGradient></defs></svg>
               </div>
               <div className="text-black font-light w-full">
                  <span className="font-medium">Did you know? </span>
                  Unlike other time tracking solutions, Indy helps you bill for your time by attaching your time tracks to invoices.
               </div>
               <div className="flex flex-col md:flex-row justify-between gap-[10px] font-bold text-indigo-900 my-[15px]">
                  <div className="">
                     <div className="text-[23px] leading-[30px] text-center md:text-left">Track, report, and get paid for your time with Indy.</div>
                     <div className=" font-light text-center md:text-left">Use promo code to get three months free!</div>
                  </div>
                  <div className="flex items-center justify-center md:items-start font-bold text-[20px] rounded-[50px] py-[20px] px-[15px] bg-white h-fit">
                     <svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" fill="currentColor" viewBox="0 0 256 256"><rect width="256" height="256" fill="none"></rect><line x1="96" y1="228" x2="160" y2="228" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="24"></line><path d="M56.2,112a71.8,71.8,0,1,1,143.6,0h0c0,35.8,7.5,52.6,14.1,64a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-28.2,14.1-64Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="24"></path><path d="M187.7,17.2a111.1,111.1,0,0,1,40.8,45.4" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="24"></path><path d="M27.5,62.6A111.1,111.1,0,0,1,68.3,17.2" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="24"></path></svg>
                     CODE:&nbsp;TIMECARD
                  </div>
               </div>
               <div className="flex justify-center item-center gap-[20px]">
                  <button className="text-white bg-gradient-to-r from-violet-500 to-indigo-900 font-medium w-[140px] h-[55px] rounded-[50px]">Start for free</button>
                  <button className="text-violet-900 w-[140px] h-[55px] rounded-[50px] border border-violet-900">Learn More</button>
               </div>
            </div>
         } */}
      </div>
   )
}

export default TimeCalc
